import { services } from '@/utils'

import squircle from '@/components/icon/squircle'
import svgIcon from '@/components/icon/svg'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'

const serviceNameViaPoint = services['otp-settings/templates'].split('/').join('.')

function renderName(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value,
        pathToTitle: 'name',
        label: this.getTranslate(`${serviceNameViaPoint}.labels.name`),
        service: serviceNameViaPoint
      }
    },
    [
      h(
        squircle,
        {
          props: {
            color: this.value.channelType,
            tooltip: this.getTranslate(`sendings.types.${this.value.channelType}`)
          },
          slot: 'icon'
        },
        [
          h(
            svgIcon,
            {
              props: {
                value: this.value.channelType,
                color: this.value.channelType,
                size: 18
              }
            }
          )
        ]
      )
    ]
  )
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${serviceNameViaPoint.replace('.', '-')}-item__info`
    },
    [ renderName.call(this, h) ]
  )
}

function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: services['otp-settings/templates']
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item hover-parent hover-parent--opacity': true,
        [`${serviceNameViaPoint.replace('.', '-')}-item`]: true
      }
    },
    [
      renderInfo.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
